import { Component, OnInit } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { Color, Label } from 'ng2-charts';

interface ItemData {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent implements OnInit {
  listOfData: ItemData[] = [];

  selectedValue = null;
  checked = true;
  demoValue = 3;
  date = null;
  isEnglish = false;
  visible = false;

  constructor() {  }
  onChange(result: Date): void {
    console.log('onChange: ', result);
  }

  ngOnInit(): void {
    for (let i = 0; i < 100; i++) {
      this.listOfData.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  }

  lineChartData: ChartDataSets[] = [
    { data: [6, 2, 3, 4, 15, 1, 1, 7, 1, 3, 2, 5, 1, 2, 4], label: 'AMS' },
    { data: [3, 5, 23, 3, 13, 4, 4, 3, 2, 5, 8, 6, 8, 4, 0], label: 'AMS2' },
  ];
  
  pieChartData: ChartDataSets[] = [
    { data: [16, 3, 4],backgroundColor: [
      'rgb(255, 99, 132)',
      'rgb(54, 162, 235)',
      'rgb(255, 205, 86)'
    ],
   },
  ];

  lineChartLabels: Label[] = ['Blocking', 'Laser', 'Marketing', 'Maxi', 'Office', 'Order', 'Peon', 'Police', 'Production', 'Siner', 'Siner', 'Siner', 'Siner', 'Siner', 'Siner'];

  lineChartOptions = {
    responsive: true,
  };

  lineChartColors: Color[] = [
    {
      borderColor: 'transparent',
      backgroundColor: '#C7505B',
    },
  ];
  pieChartColors: Color[] = [
    {
      backgroundColor: '#C7505B',
      borderColor: 'transparent',
    },
    {
      backgroundColor: '#2ECC40',
      borderColor: 'transparent',
    },
    {
      backgroundColor: '#FF4136',
      borderColor: 'transparent',
    }
  ];
  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType = 'bar';
  pieChartLabels = ['Present', 'Absent', 'Leave']
  isEdit = false;

  open(): void {
    this.visible = true;
  }

  close(): void {
    this.isEdit = false;
    this.visible = false;
  }
}
